import {classes, st} from './ItemLayout.st.css';
import React, {ReactNode} from 'react';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../constants';

export interface LayoutProps {
  descriptionWithColumns: boolean;
  Icon: ReactNode;
  MainDescription: ReactNode;
  SecondaryDescription: ReactNode;
  Details: ReactNode;
  AdditionalInfo?: ReactNode;
  shouldDisplayFrequency?: boolean;
}

export const ItemLayout = ({
  descriptionWithColumns,
  Icon,
  MainDescription,
  SecondaryDescription,
  Details,
  AdditionalInfo,
  shouldDisplayFrequency = false,
}: LayoutProps) => {
  const {experiments} = useExperiments();
  const HideMissingLineItemImagesInPaymentRequest = experiments.enabled(
    SPECS.HideMissingLineItemImagesInPaymentRequest
  );
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);

  const renderImage = () => {
    if (!HideMissingLineItemImagesInPaymentRequest || Icon) {
      return <div className={classes.icon}>{Icon}</div>;
    }
    return null;
  };

  return (
    <div className={classes.root}>
      <div className={checkoutUIRevampOrderSummary ? classes.info : classes.infoOld}>
        {renderImage()}
        <div className={shouldDisplayFrequency ? classes.contentWithFrequency : classes.content}>
          <div
            className={st(
              classes.description,
              descriptionWithColumns ? classes.descriptionWithColumns : classes.descriptionWithRows
            )}>
            <div className={classes.mainDescription}>{MainDescription}</div>
            <div
              className={
                descriptionWithColumns
                  ? st(classes.secondaryDescription, classes.shortDescription)
                  : classes.secondaryDescription
              }>
              {SecondaryDescription}
            </div>
          </div>
          <div className={classes.details}>{Details}</div>
        </div>
      </div>
      {AdditionalInfo}
    </div>
  );
};
